var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-select',{attrs:{"data-hj-whitelist":"","placeholder":"Country","multiple":_vm.multiple,"options":_vm.countries,"size":_vm.size ? _vm.size : 'md'},on:{"input":function($event){return _vm.update()}},model:{value:(_vm.country),callback:function ($$v) {_vm.country=$$v},expression:"country"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }